import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/insights/newsletters/$id")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/admin/newsletter/newsletters/$id", params: { id: params.id } });
  },
});
